import { render, staticRenderFns } from "./ThankYouStage.vue?vue&type=template&id=5ff0dff5&"
import script from "./ThankYouStage.vue?vue&type=script&lang=js&"
export * from "./ThankYouStage.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouStage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports